import { render } from "./logging.banzaicloud.io.clusterflow.vue?vue&type=template&id=7d08164e"
import script from "./logging.banzaicloud.io.clusterflow.vue?vue&type=script&lang=js"
export * from "./logging.banzaicloud.io.clusterflow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__